import { apiRequest } from '../utils/apiClient';

export type InvestorRole = 'DEVELOPER' | 'INVESTOR';

export interface InvestorApplicationPayload {
  name: string;
  email: string;
  phone?: string;
  role: InvestorRole;
  projectOrBudget?: string;
  message?: string;
  developerSlug?: string;
}

export interface FeaturedDeveloper {
  id: string;
  name: string;
  nameAr?: string | null;
  slug: string;
  logoUrl?: string | null;
  coverUrl?: string | null;
  headquartersCity?: string | null;
  region?: string | null;
  isVerified?: boolean | null;
  projectsCount?: number | null;
  listingsCount?: number | null;
}

export async function submitInvestorApplication(payload: InvestorApplicationPayload): Promise<{ id: string }> {
  const res = await apiRequest<{ success: boolean; data: { id: string } }>(
    '/investors/apply',
    { method: 'POST', body: payload },
  );
  return res.data;
}

export async function fetchFeaturedDevelopers(limit = 6): Promise<FeaturedDeveloper[]> {
  const res = await apiRequest<{ data: FeaturedDeveloper[] }>(
    `/developers?isVerified=true&pageSize=${limit}&sort=projects`,
  );
  return res.data ?? [];
}

// Bucket B opt 3 — investment demand board (developers/investors seeking real estate).
export interface InvestmentRequestItem {
  id: string;
  propertyType: string;
  listingType: string;
  minPrice: number | null;
  maxPrice: number | null;
  notes: string | null;
  createdAt: string;
  city: string | null;
  cityAr: string | null;
}

export interface InvestmentRequestsResponse {
  data: InvestmentRequestItem[];
  meta: { page: number; pageSize: number; total: number; totalPages: number };
}

export async function fetchInvestmentRequests(params: { city?: string; page?: number; pageSize?: number } = {}): Promise<InvestmentRequestsResponse> {
  const q = new URLSearchParams();
  if (params.city) q.set('city', params.city);
  q.set('page', String(params.page ?? 1));
  q.set('pageSize', String(params.pageSize ?? 12));
  return apiRequest<InvestmentRequestsResponse>(`/investors/requests?${q.toString()}`);
}

// Bucket B opt 4 — "List your property for investment" → manual admin review.
export interface InvestmentListingInput {
  title: string;
  titleAr?: string;
  description?: string;
  propertyType: string;
  address?: string;
  price?: number;
  ownerName: string;
  ownerPhone: string;
  ownerEmail?: string;
  investmentMinContribution?: number;
  investmentFundingGoal?: number;
  investmentExpectedRoi?: number;
  investmentDeadline?: string;
  investmentTerms?: string;
  deedNumber?: string;
  landIdNumber?: string;
}

export async function submitInvestmentListing(token: string, input: InvestmentListingInput): Promise<{ id: string; status: string; createdAt: string }> {
  const res = await apiRequest<{ success: boolean; data: { id: string; status: string; createdAt: string } }>(
    '/investors/listing',
    { method: 'POST', token, body: input },
  );
  return res.data;
}
